import script from "./ImpactView.vue?vue&type=script&setup=true&lang=js"
export * from "./ImpactView.vue?vue&type=script&setup=true&lang=js"

import "./ImpactView.vue?vue&type=style&index=0&id=65612e1d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65612e1d"]])

export default __exports__